import React, { Fragment } from 'react';
import { Item, Card, Divider } from 'semantic-ui-react';
import PassengerView from '../PassengerView';
import mapConnection from '../../utils/connectionMapper';

import TicketInformation from './TicketInformation';
import Flights from './Flights';
import ButtonsBlock from './ButtonsBlock';

const TicketDetails = ({
  ticket,
  onTicketUpdated,
  hideLoading,
  showLoading,
  match,
  history,
}) => {
  const {
    id,
    number,
    flightsPassengerTicketsConnection,
    createdAt,
    updatedAt,
    pnr,
    token,
    source,
    unclaimableBy,
    unclaimableAt,
    widgetCommentFromPax,
    passengerFirstName,
    passengerLastName,
    anonymizedAt
  } =
    ticket || '';

  const commonProps = {
    match,
    history,
    onTicketUpdated,
    hideLoading,
    showLoading
  };
  const ticketInformationData = {
    createdAt,
    updatedAt,
    pnr,
    token,
    source,
    unclaimableBy,
    unclaimableAt,
    widgetCommentFromPax,
    paxName: `${passengerFirstName} ${passengerLastName}`,
    ...commonProps
  };

  const flights = flightsPassengerTicketsConnection
    ? mapConnection(flightsPassengerTicketsConnection)
    : [];
  return (
    <Fragment>
      <Card.Content textAlign="left">
        <Card.Header>{number}</Card.Header>
        <Item.Group>
          <TicketInformation {...ticketInformationData} />
          <Divider />
          <PassengerView passenger={ticket} />
          <Divider />
          <Flights id={id} flights={flights} {...commonProps} />
        </Item.Group>
      </Card.Content>
      <ButtonsBlock
        isAnonymized={!!anonymizedAt || !passengerLastName}
        {...commonProps}
      />
    </Fragment>
  );
};

export default TicketDetails;



// WEBPACK FOOTER //
// ./src/component/TicketPage/TicketDetails.js